import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  draggableIndicator: {
    cursor: "grab",
  },
  showOnHover: {
    visibility: "hidden",
  },
  draggableItemContainer: {
    "&:hover $showOnHover": {
      visibility: "visible",
    },
    "& .MuiAutocomplete-clearIndicator": {
      marginRight: "2px",
      "& svg": {
        fill: theme.palette.events.lightBlack,
      },
    },
  },
  draggableItemPopper: {
    width: "340px",
    zIndex: zIndexes.modalZIndex + 1,
  },
  addEntryButton: {
    marginTop: "15px",
  },
  deleteEntryButton: {
    marginLeft: "5px",
    "& path": {
      fill: theme.palette.events.lightBlack,
    },
  },
  addEntryButtonContent: {
    display: "flex",
    alignItems: "center",
  },
  inputContainer: {
    paddingRight: "4px",
  },
}));
